<div class="container">
  <ion-spinner class="spinner" name="bubbles" />
  {{ loadingText() }}
</div>
